// extracted by mini-css-extract-plugin
export default {"standardAnchor":"manage-equipment_standardAnchor__lGp98"};